module.exports = __webpack_public_path__ + "public/images/girl-with-flower.52391aeb98b532d0082e2753a1e57cc6.png";